var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dashboard-financeiro container"
  }, [_c('div', {
    staticClass: "saldo mb-4"
  }, [_c('div', [_c('span', {
    staticClass: "fw-bold text-muted"
  }, [_vm._v("Saldo em conta")]), _c('div', {
    staticClass: "d-flex align-items-center gap-2 mt-1"
  }, [_c('span', {
    staticClass: "display-4 text-success"
  }, [_vm._v(" " + _vm._s(_vm.mostrarSaldo ? "R$ " + _vm.numberToReal(_vm.dados.saldo_em_conta, 2) : "••••••") + " ")]), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Esconder valores',
      expression: "'Esconder valores'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    staticClass: "p-0 ms-2",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "variant": "link"
    },
    on: {
      "click": _vm.alternarSaldo
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": _vm.mostrarSaldo ? ' eye-slash' : ' eye',
      "font-scale": "1.5"
    }
  })], 1)], 1)])]), _c('div', {
    staticClass: "d-flex flex-wrap align-items-center justify-content-between mb-3",
    staticStyle: {
      "gap": "1rem"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center",
    staticStyle: {
      "gap": "1rem"
    }
  }, [_c('b-dropdown', {
    staticClass: "me-2",
    attrs: {
      "id": "filtro-periodo",
      "text": _vm.labelPeriodo,
      "variant": "outline-primary"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function click($event) {
        return _vm.setFiltro('day');
      }
    }
  }, [_vm._v("Hoje")]), _c('b-dropdown-item', {
    on: {
      "click": function click($event) {
        return _vm.setFiltro('week');
      }
    }
  }, [_vm._v("Esta semana")]), _c('b-dropdown-item', {
    on: {
      "click": function click($event) {
        return _vm.setFiltro('month');
      }
    }
  }, [_vm._v("Este mês")]), _c('b-dropdown-item', {
    on: {
      "click": function click($event) {
        return _vm.setFiltro('year');
      }
    }
  }, [_vm._v("Este ano")]), _c('b-dropdown-item', {
    on: {
      "click": function click($event) {
        return _vm.setFiltro('personalizado');
      }
    }
  }, [_vm._v("Personalizado")])], 1), _vm.filtroPeriodo === 'personalizado' ? _c('div', {
    staticClass: "d-flex align-items-center",
    staticStyle: {
      "gap": "0.5rem"
    }
  }, [_c('b-form-datepicker', {
    staticClass: "w-auto",
    attrs: {
      "placeholder": "Início",
      "size": "sm"
    },
    model: {
      value: _vm.dataInicio,
      callback: function callback($$v) {
        _vm.dataInicio = $$v;
      },
      expression: "dataInicio"
    }
  }), _c('b-form-datepicker', {
    staticClass: "w-auto",
    attrs: {
      "placeholder": "Fim",
      "size": "sm"
    },
    model: {
      value: _vm.dataFim,
      callback: function callback($$v) {
        _vm.dataFim = $$v;
      },
      expression: "dataFim"
    }
  }), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.buscarDadosDashboard
    }
  }, [_c('b-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "funnel-fill"
    }
  }), _vm._v(" Aplicar ")], 1)], 1) : _vm._e()], 1)]), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('InfoBox', {
    attrs: {
      "cor": "success",
      "titulo": "Recebidas",
      "icone": "check-circle",
      "valor": _vm.dados.recebidas.valor_total,
      "liquido": _vm.dados.recebidas.liquido,
      "clientes": _vm.dados.recebidas.clientes,
      "cobrancas": _vm.dados.recebidas.cobrancas,
      "tituloBIcon": "Cobranças recebidas dentro do período"
    }
  }), _c('InfoBox', {
    attrs: {
      "cor": "primary",
      "titulo": "Confirmadas",
      "icone": "check",
      "valor": _vm.dados.confirmadas.valor_total,
      "liquido": _vm.dados.confirmadas.liquido,
      "clientes": _vm.dados.confirmadas.clientes,
      "cobrancas": _vm.dados.confirmadas.cobrancas,
      "tituloBIcon": "Cobranças recebidas dentro do período, mas que estão aguardando o repasse."
    }
  }), _c('InfoBox', {
    attrs: {
      "cor": "warning",
      "titulo": "Aguardando pagamento",
      "icone": "clock",
      "valor": _vm.dados.aguardando_pagamento.valor_total,
      "liquido": _vm.dados.aguardando_pagamento.liquido,
      "clientes": _vm.dados.aguardando_pagamento.clientes,
      "cobrancas": _vm.dados.aguardando_pagamento.cobrancas,
      "tituloBIcon": "Cobranças previstas para recebimento dentro do período."
    }
  }), _c('InfoBox', {
    attrs: {
      "cor": "danger",
      "titulo": "Vencidas",
      "icone": "x-circle",
      "valor": _vm.dados.vencidas.valor_total,
      "liquido": _vm.dados.vencidas.liquido,
      "clientes": _vm.dados.vencidas.clientes,
      "cobrancas": _vm.dados.vencidas.cobrancas,
      "tituloBIcon": "Cobranças vencidas dentro do período e que não foram pagas."
    }
  }), _c('ExtratoFinanceiro', {
    attrs: {
      "filtroPeriodo": _vm.filtroPeriodo,
      "dataInicio": _vm.dataInicio,
      "dataFim": _vm.dataFim
    }
  })], 1), _c('b-modal', {
    attrs: {
      "title": "Transferência Pix",
      "hide-footer": ""
    },
    model: {
      value: _vm.mostrarModalTransferencia,
      callback: function callback($$v) {
        _vm.mostrarModalTransferencia = $$v;
      },
      expression: "mostrarModalTransferencia"
    }
  }, [_c('p', [_vm._v(" As 30 primeiras Transferências ou Pix do mês são gratuitas, depois disso será cobrada uma taxa de R$ 2,00 para Pix com chave ou manual. ")]), _c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.enviarTransferencia.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo da Chave"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.tiposChave,
      "required": ""
    },
    model: {
      value: _vm.transferencia.tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.transferencia, "tipo", $$v);
      },
      expression: "transferencia.tipo"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Chave Pix"
    }
  }, [_c('b-form-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: _vm.transferencia.chave,
      callback: function callback($$v) {
        _vm.$set(_vm.transferencia, "chave", $$v);
      },
      expression: "transferencia.chave"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Valor"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    model: {
      value: _vm.transferencia.valor,
      callback: function callback($$v) {
        _vm.$set(_vm.transferencia, "valor", $$v);
      },
      expression: "transferencia.valor"
    }
  }, 'money', _vm.configMoney, false))], 1), _c('b-form-group', {
    attrs: {
      "label": "Descrição"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3"
    },
    model: {
      value: _vm.transferencia.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.transferencia, "descricao", $$v);
      },
      expression: "transferencia.descricao"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        _vm.mostrarModalTransferencia = false;
      }
    }
  }, [_vm._v("Cancelar")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm._v("Confirmar Transferência")])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };